import { render, staticRenderFns } from "./StudentExtras.vue?vue&type=template&id=3934565c"
import script from "./StudentExtras.vue?vue&type=script&lang=js"
export * from "./StudentExtras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3934565c')) {
      api.createRecord('3934565c', component.options)
    } else {
      api.reload('3934565c', component.options)
    }
    module.hot.accept("./StudentExtras.vue?vue&type=template&id=3934565c", function () {
      api.rerender('3934565c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/profile/StudentExtras.vue"
export default component.exports